var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"container"},[_c('img',{staticClass:"errorImg",attrs:{"src":"https://picture.shjyyyxx.com/image/gongogngongtouxiang.jpg","alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }